var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GridCol, GridContainer, GridRow, getTestId } from '@airtel/air-design-system';
import { Fragment } from 'react';
import { LinkListItemWidget } from '../link-list-item-widget';
import { PriceBreakupWidget } from '../price-breakup-widget';
import { TrackOrderStepperWidget } from '../track-order-stepper-widget';
export var TrackingDetailedWidgetComponent = props => {
  var testID = props.testID,
    _props$gridRowProps = props.gridRowProps,
    gridRowProps = _props$gridRowProps === void 0 ? {} : _props$gridRowProps,
    _props$linkListItemWi = props.linkListItemWidgetProps,
    linkListItemWidgetProps = _props$linkListItemWi === void 0 ? {} : _props$linkListItemWi,
    _props$priceBreakUpWi = props.priceBreakUpWidgetProps,
    priceBreakUpWidgetProps = _props$priceBreakUpWi === void 0 ? {} : _props$priceBreakUpWi,
    _props$trackOrderStep = props.trackOrderStepperWidgetProps,
    trackOrderStepperWidgetProps = _props$trackOrderStep === void 0 ? {
      steps: []
    } : _props$trackOrderStep,
    _props$gridColLinkLis = props.gridColLinkListProps,
    gridColLinkListProps = _props$gridColLinkLis === void 0 ? {} : _props$gridColLinkLis,
    _props$gridColPriceBr = props.gridColPriceBreakupProps,
    gridColPriceBreakupProps = _props$gridColPriceBr === void 0 ? {} : _props$gridColPriceBr,
    onUserAction = props.onUserAction,
    restProps = __rest(props, ["testID", "gridRowProps", "linkListItemWidgetProps", "priceBreakUpWidgetProps", "trackOrderStepperWidgetProps", "gridColLinkListProps", "gridColPriceBreakupProps", "onUserAction"]);
  var columnBreakpoints = {
    breakpoints: {
      md: 6,
      xs: 12
    }
  };
  var isStepperWidgetPresent = !!trackOrderStepperWidgetProps && !!Object.keys(trackOrderStepperWidgetProps).length;
  var LinkListAndPriceBreakupWrapper = () => {
    var props = Object.assign(Object.assign({}, columnBreakpoints), {
      noGutter: true
    });
    var linkListColProps = Object.assign(Object.assign({}, !isStepperWidgetPresent && Object.assign(Object.assign({}, columnBreakpoints), gridColLinkListProps.breakpoints)), gridColLinkListProps);
    var priceBreakupColProps = Object.assign(Object.assign({}, !isStepperWidgetPresent && Object.assign(Object.assign({}, columnBreakpoints), gridColPriceBreakupProps.breakpoints)), gridColPriceBreakupProps);
    var Component = isStepperWidgetPresent ? GridCol : Fragment;
    return _jsxs(Component, Object.assign({}, isStepperWidgetPresent && props, {
      children: [_jsx(GridCol, Object.assign({}, linkListColProps, {
        children: _jsx(LinkListItemWidget, Object.assign({}, linkListItemWidgetProps, {
          onUserAction: onUserAction
        }))
      })), _jsx(GridCol, Object.assign({}, priceBreakupColProps, {
        children: _jsx(PriceBreakupWidget, Object.assign({}, priceBreakUpWidgetProps, {
          onUserAction: onUserAction
        }))
      }))]
    }));
  };
  return _jsx(GridContainer, Object.assign({}, restProps, getTestId(testID), {
    children: _jsxs(GridRow, Object.assign({}, gridRowProps, {
      children: [_jsx(LinkListAndPriceBreakupWrapper, {}), isStepperWidgetPresent && _jsx(GridCol, Object.assign({}, columnBreakpoints, {
        children: _jsx(TrackOrderStepperWidget, Object.assign({}, trackOrderStepperWidgetProps, {
          onUserAction: onUserAction
        }))
      }))]
    }))
  }));
};
TrackingDetailedWidgetComponent.genericRendererKey = 'AirTrackingDetailedWidget';